export { DatasetDescription };

/**
 * A generic dataset description.
 * 
 * @author rkoppe <roland.koppe@awi.de>
 * @memberof vef.data
 */
class DatasetDescription {

    citation = '';
    relations = {
        relatedTo: [],
        furtherDetails: []
    };
    projects = [];
    events = {};
    parameters = [];
    license = '';
    url = '';

}